import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { styles } from "./style";

interface OwnProps {
}

type Props = OwnProps & WithStyles<typeof styles> & Mui.TableCellProps;

class Component extends React.Component<Props> {

	public render() {
		const { classes = {}, ...others } = this.props;
		return (
			<Mui.TableCell
				{...others}
				classes={{
					root: classes.root,
				}}
			/>
		);
	}
}

export const TableCell = withStyles(Component, styles);